var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconeVisaoGeral(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 15,
    viewBox: "0 0 20 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    width: 20,
    height: 15,
    x: 0,
    y: 0
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    maskContentUnits: "userSpaceOnUse",
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 15,
    x: 0,
    y: 0,
    fill: "black"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "white",
    xlinkHref: "#rect-1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "none",
    xlinkHref: "#rect-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "M1.6666565 0h16.666687C19.25265504.00274658 19.99725343.74734497 20 1.6666565l-.0083313 11.666687c0 .91720582-.74111938 1.66207886-1.6583252 1.6666565H1.6666565C.74734496 14.99725342.00274657 14.25265503 0 13.3333435V1.6666565C.00274658.74734496.74734497.00274657 1.6666565 0zm0 13.33331299h16.66665649V1.66665649H1.66665649V13.333313z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "M8.14248657 5.0166626c0 1.1736145-.9513855 2.125-2.125 2.125-1.17227173-.00320435-2.12179565-.95272827-2.125-2.125 0-1.1736145.9513855-2.125 2.125-2.125s2.125.9513855 2.125 2.125zm-1.47055053-.27108765c-.10964966-.26467895-.36791993-.43725586-.65441895-.43725586-.39083862.00091553-.70742798.31750488-.7083435.7083435 0 .28649903.1725769.5447693.43725585.65441895.26470948.10961914.56936646.04901123.77194214-.15356445.20257569-.20257568.2631836-.50723267.15356446-.77194214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    d: "M6.01083374 8.1875c1.11584473 0 3.29751587.84832764 3.29751587 2.8125v1.10751343H2.71417236V11c0-1.96417236 2.18084717-2.8125 3.29666138-2.8125zm0 1.56332397c-.7159729.0314026-1.39916992.30895997-1.93417358.78582764h3.86834716c-.53375244-.47888183-1.21768188-.7567749-1.93417358-.78582764z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 4.167,
    height: 1.667,
    x: 13.333,
    y: 3.333,
    fill: "#FFFFFF",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 0.833,
    x: 13.75,
    y: 3.75,
    fill: "none",
    stroke: "#FFFFFF",
    strokeDasharray: "0 0 0 0",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 4.167,
    height: 1.667,
    x: 13.333,
    y: 6.667,
    fill: "#FFFFFF",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 0.833,
    x: 13.75,
    y: 7.083,
    fill: "none",
    stroke: "#FFFFFF",
    strokeDasharray: "0 0 0 0",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 4.167,
    height: 1.667,
    x: 13.333,
    y: 10,
    fill: "#FFFFFF",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.333,
    height: 0.833,
    x: 13.75,
    y: 10.417,
    fill: "none",
    stroke: "#FFFFFF",
    strokeDasharray: "0 0 0 0",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 0,
    ry: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.667,
    height: 1.667,
    x: 10.833,
    y: 3.333,
    fill: "#FFFFFF",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.833,
    height: 0.833,
    x: 11.25,
    y: 3.75,
    fill: "none",
    stroke: "#FFFFFF",
    strokeDasharray: "0 0 0 0",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.667,
    height: 1.667,
    x: 10.833,
    y: 6.667,
    fill: "#FFFFFF",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.833,
    height: 0.833,
    x: 11.25,
    y: 7.083,
    fill: "none",
    stroke: "#FFFFFF",
    strokeDasharray: "0 0 0 0",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 0,
    ry: 0
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    width: 1.667,
    height: 1.667,
    x: 10.833,
    y: 10,
    fill: "#FFFFFF",
    rx: 0,
    ry: 0
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.833,
    height: 0.833,
    x: 11.25,
    y: 10.417,
    fill: "none",
    stroke: "#FFFFFF",
    strokeDasharray: "0 0 0 0",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeWidth: 1,
    rx: 0,
    ry: 0
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeVisaoGeral);
export default __webpack_public_path__ + "static/media/icone-visao-geral.0b4386308d949d19836ff639710e6066.svg";
export { ForwardRef as ReactComponent };